var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.inlineMessage.message
        ? _c(
            "v-alert",
            {
              staticClass: "mt-0 mb-3",
              attrs: { type: _vm.inlineMessage.type }
            },
            [_vm._v("\n    " + _vm._s(_vm.inlineMessage.message) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "al-view" },
        [
          _c(
            "v-toolbar",
            {
              class: [
                _vm.processing
                  ? "al-view-card-top-color-processing"
                  : "al-view-card-top-color"
              ]
            },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-card-title", [_vm._v("Notices")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.processing
                    ? _c("v-progress-circular", {
                        staticClass: "mr-3",
                        attrs: {
                          indeterminate: true,
                          rotate: 0,
                          size: 32,
                          width: 4,
                          color: "white"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            { ref: "form", on: { submit: _vm.onSubmit } },
            [
              !_vm.apiKeyConfirmed
                ? _c(
                    "v-row",
                    { staticClass: "mt-3 mx-0 align-top" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    sm: "12",
                                    md: "12",
                                    lg: "6",
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      label: "API Key",
                                      disabled: _vm.processing,
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.apiKey,
                                      callback: function($$v) {
                                        _vm.apiKey = $$v
                                      },
                                      expression: "apiKey"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        outlined: "",
                                        disabled: _vm.processing
                                      },
                                      on: { click: _vm.loadNotices }
                                    },
                                    [_vm._v("Load Notices")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.apiKeyConfirmed
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { sm: "12", md: "12", lg: "6", cols: "12" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "pa-2 ma-2",
                              attrs: { outlined: "" }
                            },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n                      Create New Notice\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider", { staticClass: "mb-2" }),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      outlined: "",
                                      label: "Notice Title",
                                      disabled: _vm.processing,
                                      rules: [_vm.rules.required],
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.newNotice.title,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newNotice, "title", $$v)
                                      },
                                      expression: "newNotice.title"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      outlined: "",
                                      "auto-grow": "",
                                      label: "Notice Description",
                                      disabled: _vm.processing,
                                      rules: [_vm.rules.required],
                                      rows: "5",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.newNotice.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newNotice,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "newNotice.description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-switch", {
                                staticClass: "mb-0 ml-2",
                                attrs: {
                                  label: "Important",
                                  disabled: _vm.processing
                                },
                                model: {
                                  value: _vm.newNotice.important,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newNotice, "important", $$v)
                                  },
                                  expression: "newNotice.important"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        outlined: "",
                                        disabled: _vm.processing,
                                        block: ""
                                      },
                                      on: { click: _vm.addNotice }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Send Notice\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.apiKeyConfirmed
            ? _c(
                "v-card",
                { staticClass: "pa-2 ma-2", attrs: { outlined: "" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "subtitle-1 font-weight-bold" },
                    [_vm._v("\n              Existing Notices\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { staticClass: "pa-0", attrs: { fluid: "" } },
                    _vm._l(_vm.notices, function(n, i) {
                      return _c(
                        "v-card",
                        {
                          key: n.id,
                          staticClass: "mb-2 pa-2",
                          attrs: { outlined: "" }
                        },
                        [
                          n.isEditing
                            ? [
                                _c("v-text-field", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    label: "Notice Title",
                                    disabled: _vm.processing,
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: n.editTitle,
                                    callback: function($$v) {
                                      _vm.$set(n, "editTitle", $$v)
                                    },
                                    expression: "n.editTitle"
                                  }
                                }),
                                _vm._v(" "),
                                _c("v-textarea", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    outlined: "",
                                    "auto-grow": "",
                                    dense: "",
                                    label: "Notice Description",
                                    disabled: _vm.processing,
                                    "hide-details": ""
                                  },
                                  model: {
                                    value: n.editDescription,
                                    callback: function($$v) {
                                      _vm.$set(n, "editDescription", $$v)
                                    },
                                    expression: "n.editDescription"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "d-flex align-center",
                                        attrs: { cols: "12" }
                                      },
                                      [
                                        _c("v-switch", {
                                          staticClass: "ma-0",
                                          attrs: {
                                            label: "Important",
                                            "hide-details": "",
                                            disabled: _vm.processing
                                          },
                                          model: {
                                            value: n.editImportant,
                                            callback: function($$v) {
                                              _vm.$set(n, "editImportant", $$v)
                                            },
                                            expression: "n.editImportant"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "12" }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              small: "",
                                              color: "success",
                                              outlined: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveNotice(i)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                              Save\n                          "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              outlined: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.cancelEdit(i)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                              Cancel\n                          "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "mb-2",
                                    attrs: { align: "center" }
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "d-flex",
                                        attrs: { cols: "8" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-medium mr-3"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                  " +
                                                _vm._s(n.title) +
                                                "\n                              "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        n.important
                                          ? _c(
                                              "v-chip",
                                              {
                                                staticClass: "ma-0",
                                                attrs: {
                                                  color: "red lighten-3",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                  !\n                              "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "4" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "grey--text text--darken-1"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                  " +
                                                _vm._s(_vm.getDate(n)) +
                                                "\n                              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-2" }, [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(n.description) +
                                      "\n                      "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "12" }
                                      },
                                      [
                                        !_vm.simpleDisplay
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "mr-1",
                                                attrs: {
                                                  small: "",
                                                  color: "primary",
                                                  outlined: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.enableEdit(i)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                  Edit\n                              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "error",
                                              outlined: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openDeleteDialog(i)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                  Delete\n                              "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.deleteDialog.show,
            callback: function($$v) {
              _vm.$set(_vm.deleteDialog, "show", $$v)
            },
            expression: "deleteDialog.show"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Are you sure?")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n                                  This action cannot be undone.\n                              "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeDeleteDialog }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", text: "" },
                      on: { click: _vm.confirmDelete }
                    },
                    [
                      _vm._v(
                        "\n                                  Delete\n                              "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }